import { permutationsWithRepetition } from "shared/src/util.mjs";

const textSearchFields = ["first_name", "last_name"];

const numberSearchFields = ["birth_number", "phone", "labs_id"];

function matchDate(dateStr) {
  const m = dateStr.match(/^(\d{1,2})\.(\d{1,2})\.(\d{4})$/);

  return m == null
    ? null
    : [m[3], m[2].padStart(2, "0"), m[1].padStart(2, "0")].join("-");
}

/**
 * @param {string[]} parts
 *
 * @return {string[]}
 */
function searchedFields(parts) {
  const allNumbers = parts.every((part) => part.match(/^\d+$/) != null);

  if (allNumbers) {
    return numberSearchFields;
  }

  if (parts.length === 1) {
    return [...textSearchFields, "email"];
  }

  return textSearchFields;
}

export function createClientFilter(term) {
  const parts = term.split(" ").filter((p) => p.length !== 0);

  if (parts.length === 0) {
    return;
  }

  const partsByType = parts.reduce(
    (acc, part) => {
      const date = matchDate(part);
      if (date != null) {
        acc.date.push(date);
      } else {
        acc.text.push(part);
      }

      return acc;
    },
    { date: [], text: [] },
  );

  const textParts = partsByType.text;
  const dateParts = partsByType.date;
  const addDateParts =
    dateParts.length === 0
      ? (filters) => filters
      : (filters) => {
          dateParts.forEach((p) => filters.push({ birthdate: { eq: p } }));

          return filters;
        };

  const filter = {
    current_company: { eq: true },
    or: permutationsWithRepetition(
      searchedFields(textParts),
      textParts.length,
    ).map((fields) => {
      const filters = fields.map((f, i) => {
        return { [f]: { contains: textParts[i] } };
      });

      return {
        and: addDateParts(filters),
      };
    }),
  };

  return filter;
}
